import App from '../../../vendor_core/core/src/App';
import GameModel from '../../../vendor_core/core/src/model/GameModel';
import SpinModel from '../../../vendor_core/core/src/model/SpinModel';
import { OverlayType } from '../../../vendor_core/core/src/server/data/ISpinData';
import { DefaultLayers } from '../../../vendor_core/core/src/utils/Layers';
import Layout from '../../../vendor_core/core/src/utils/Layout';
import ViewManager from '../../../vendor_core/core/src/utils/ViewManager';
import Reel from '../../../vendor_core/core/src/views/Reel';
import BBModel from '../model/BBModel';
import BBReelGroup from '../view/BBReelGroup';
import BBReelSymbol from '../view/BBSymbol';

const searchWilds = (reels: number[][]) => {
    let res = [];
    reels.forEach((reel, i) => {
        reel.forEach((row, j) => {
            if (row == 0) {
                res.push({ x: i, y: j, counter: 0, groups: [] })
            }
        })
    });

    return res;
}

const repositionLogo = () => {
    // console.log(GameModel.gameConfig.featureBye);
    // debugger
    if (GameModel.gameConfig.featureBye) {
        if (!Layout.isLandscape()) {
            let backgroundLayer = ViewManager.getLayer(DefaultLayers.Background).getCurrentScene();
            let position;
            if (SpinModel.isInFreespins()) {
                position = backgroundLayer.positions.get("logo_fs");
            } else {
                position = backgroundLayer.positions.get("logo");
            }
            let logoAnim = backgroundLayer.spineAnimations.get("logo");
            let logoAnimCont = backgroundLayer.spineAnimations.get("logo").parent;
            logoAnimCont.position.x = (position.x * Layout.globalScale) - (((logoAnim.animConfig.containerSize - 1) / 2) * logoAnimCont.width);
        }
    } else {
        if (!Layout.isLandscape()) {
            let backgroundLayer = ViewManager.getLayer(DefaultLayers.Background).getCurrentScene();
            let position = backgroundLayer.positions.get("logo_fs");;
            let logoAnim = backgroundLayer.spineAnimations.get("logo");
            let logoAnimCont = backgroundLayer.spineAnimations.get("logo").parent;
            logoAnimCont.position.x = (position.x * Layout.globalScale) - (((logoAnim.animConfig.containerSize - 1) / 2) * logoAnimCont.width);
        }
    }
}

const getModifiedExplodedItems = (reel: Reel, explodedItems: boolean[]) => {
    if (explodedItems.length === 0) {
        return []
    }
    const result = [...explodedItems];
    const overlay = BBModel.getOverlays(OverlayType.Moving);
    let wildsMovedToReel = [];
    let wildsMovedFromReel = [];
    if (overlay.length > 0) {
        let fromVerb = BBModel.getMovedFromReelWilds(reel.reelIndex);
        let toVerb = BBModel.getMovedToReelWilds(reel.reelIndex);
        if (fromVerb.length > 0) {
            wildsMovedFromReel = Array(App.config.numReels).fill(null);
            fromVerb.forEach(row => {
                wildsMovedFromReel[row] = 0
            });
        }

        if (toVerb.length > 0) {
            wildsMovedToReel = Array(App.config.numReels).fill(null);
            toVerb.forEach(row => {
                wildsMovedToReel[row] = 0
            });

        }
    }

    wildsMovedToReel.forEach((row, index) => row === 0 ? result[index] = false : null);
    wildsMovedFromReel.forEach((row, index) => row === 0 ? result[index] = true : null);

    return result
}

const randomIntFromInterval = (min: number, max: number): number => Math.floor(Math.random() * (max - min + 1) + min);

const getRandomSymbol = (reelGroup: BBReelGroup, options: {
    reelInterval: {
        start: number,
        end: number
    },
    rowInterval: {
        start: number,
        end: number
    }
}): {
    symbol: BBReelSymbol,
    reelIndex: number,
    rowIndex: number
} => {

    let reelIndex = BBUtils.randomIntFromInterval(options.reelInterval.start, options.reelInterval.end);
    let rowIndex = BBUtils.randomIntFromInterval(options.rowInterval.start, options.rowInterval.end);
    let symbol = reelGroup.reels[reelIndex].symbols[rowIndex] as BBReelSymbol;
    if (symbol.id === 0) {
        return getRandomSymbol(reelGroup, options)
    } else {
        return {
            symbol: symbol,
            reelIndex: reelIndex,
            rowIndex: rowIndex
        }
    }
}


const BBUtils = {
    searchWilds,
    randomIntFromInterval,
    getModifiedExplodedItems,
    getRandomSymbol,
    repositionLogo
};

export default BBUtils
